/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	scmPromos: {
		personalized: null,
		promosList: []
	}
};

export const contentCardsSlice = createSlice({
	name: 'contentCards',
	initialState,
	reducers: {
		setScmPromos(state, action) {
			state.scmPromos = { ...action.payload };
		}
	}
});

export const { setScmPromos } = contentCardsSlice.actions;

export default contentCardsSlice.reducer;
